// The UI reads everything through one Services object (src/services/api.ts), provided once by
// Hud and read with useServices(). Components never import view/ or world/ code.

import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import type { Services } from '../services/api.ts';

export const ServicesContext = createContext<Services | null>(null);

export function useServices(): Services {
  const services = useContext(ServicesContext);
  if (!services) {
    throw new Error('ui: useServices() outside <Hud>');
  }
  return services;
}
